import { render, staticRenderFns } from "./CadastralIncome.vue?vue&type=template&id=1b50f0d6&"
import script from "./CadastralIncome.vue?vue&type=script&lang=ts&"
export * from "./CadastralIncome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports